import { render } from "./settings-global.vue?vue&type=template&id=64b0d369"
import script from "./settings-global.vue?vue&type=script&lang=js"
export * from "./settings-global.vue?vue&type=script&lang=js"

import "./settings-global.vue?vue&type=style&index=0&id=64b0d369&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__